import React from 'react';
import { Users, FileText, Layers, ShoppingCart, Bot, ArrowRight } from 'lucide-react';

const DashboardQuickActions: React.FC = () => {
  const actions = [
    {
      title: 'Customers',
      desc: 'View accounts & billing portal',
      view: 'customers',
      icon: Users,
      iconBg: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-950 dark:text-indigo-400',
    },
    {
      title: 'Invoices',
      desc: 'Issue, view, and track payments',
      view: 'invoices',
      icon: FileText,
      iconBg: 'bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-400',
    },
    {
      title: 'Plans & Add-ons',
      desc: 'Configure tiers & discount rules',
      view: 'plans',
      icon: Layers,
      iconBg: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-400',
    },
    {
      title: 'Lost Carts',
      desc: 'Recover abandoned checkouts',
      view: 'abandoned',
      icon: ShoppingCart,
      iconBg: 'bg-amber-50 text-amber-600 dark:bg-amber-950 dark:text-amber-400',
    },
    {
      title: 'Smart Advisor',
      desc: 'AI pricing & growth consulting',
      view: 'ai',
      icon: Bot,
      iconBg: 'bg-purple-50 text-purple-600 dark:bg-purple-950 dark:text-purple-400',
    },
  ];

  const handleNavigate = (view: string) => {
    if ((window as any).setActiveView) {
      (window as any).setActiveView(view);
    }
  };

  return (
    <div className="space-y-2.5">
      <div className="flex items-center justify-between">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider">Quick Navigation</h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {actions.map((act, idx) => {
          const Icon = act.icon;
          return (
            <button
              key={idx}
              onClick={() => handleNavigate(act.view)}
              className="bg-white dark:bg-slate-800 p-3.5 rounded-xl border border-slate-200 dark:border-slate-700 shadow-xs hover:border-indigo-300 dark:hover:border-indigo-600 hover:shadow-sm transition-all text-left group flex items-center justify-between"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className={`p-2 rounded-lg ${act.iconBg} shrink-0`}>
                  <Icon className="w-4 h-4" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-slate-900 dark:text-white truncate group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                    {act.title}
                  </p>
                  <p className="text-[10px] text-slate-400 dark:text-slate-500 truncate">{act.desc}</p>
                </div>
              </div>
              <ArrowRight className="w-3.5 h-3.5 text-slate-300 dark:text-slate-600 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 shrink-0 transition-transform group-hover:translate-x-0.5" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardQuickActions;
